export const BLINKER_COLORS = ['black', 'white', 'gold'];
